<template>
  <div>
    <b-dropdown-item class="drop-item" 
        @click="callAction"
      >
        <img
          :src="require(`@/assets/${image}`)"
          class="dropItem"
          :alt="`${altTxt}`"
        />
        {{text}}
      </b-dropdown-item>
  </div>
</template>

<script>
export default {
  name: "DropDownItemModal.vue",
  props: ["image", "route", "text", "altTxt", "showItem", "modal"],
  data() {
    return {
    }
  },
  methods: {
    callAction(){
      if(this.modal)
        this.$bvModal.show(this.modal)
    },
  }
}
</script>

<style scoped>

img.dropItem {
  max-height: 25px;
  max-width: 25px;
  border-radius: 5px;
  margin-right: 10px;
}

</style>